// Input field with a error message

import { useState } from 'react';
import './Input.scss';

export default function Input({
  name,
  placeholder,
  type,
  inputMode,
  onChange,
  onFocus,
  onBlur,
  onKeyDown,
  onClick,
  onClear,
  inputRef,
  value,
  error,
  className,
  small,
  disabled,
}) {
  const [visible, setVisible] = useState(false);
  const inputType =
    type === 'password' ? (visible ? 'text' : 'password') : type;

  return (
    <div
      className={
        'input' +
        (className ? ' ' + className : '') +
        (onClear ? ' has-clear' : '') +
        (disabled ? ' disabled' : '')
      }
    >
      <input
        ref={inputRef}
        className={(error ? 'error' : '') + (small ? ' small' : '')}
        name={name}
        placeholder={placeholder}
        type={inputType}
        inputMode={inputMode}
        onChange={onChange}
        onFocus={onFocus}
        onBlur={onBlur}
        onKeyDown={onKeyDown}
        onClick={onClick}
        value={value}
        disabled={disabled}
      />
      {/* The clear button and the password toggle share the right edge, so a
          field never gets both — a password is not something to wipe in place */}
      {onClear && !disabled && (
        <button
          type='button'
          className={'clear-btn' + (small ? ' small' : '')}
          // Keeps the focus in the field: without this the click blurs it
          // first, and a field that saves on blur would write the very value
          // the button is about to clear
          onMouseDown={(e) => e.preventDefault()}
          onClick={onClear}
          aria-label={placeholder ? `Clear ${placeholder}` : 'Clear'}
        >
          <p className='fa-cross' />
        </button>
      )}
      {type === 'password' && (
        <i
          className={
            'toggle-password fa-eye-' +
            (visible ? 'open' : 'closed') +
            (small ? ' small' : '')
          }
          onClick={() => setVisible((v) => !v)}
          role='button'
          aria-label={visible ? 'Hide password' : 'Show password'}
        />
      )}
      <p className={'error-msg' + (error ? ' visible' : '')}>{error}</p>
      <p className={'label' + (value ? ' visible' : '')}>{placeholder}</p>
    </div>
  );
}
